import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            常见<span className="text-primary-500">问题</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500">关于红桃视频，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200 overflow-hidden transition-colors duration-200"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.question}</span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className={`text-lg ${openIndex === index ? 'text-primary-500 ri-subtract-line' : 'text-foreground-400 ri-add-line'}`} />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}